const joinSaleDataPush = () => {
  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: "live-online|original",
        action: "navigate",
        section: "sales-card",
      },
    });
  }
};

export default joinSaleDataPush;

